import React from 'react';
import { Box, Typography, Button, Paper, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { CheckCircleOutline, EmojiEventsOutlined, StarRounded } from '@material-ui/icons';

const StyledPaper = styled(Paper)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
}));

const StyledButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1, 4),
    borderRadius: 25,
    alignSelf: 'center',
    width: '80%',
}));

const SimDoctorInfoScreen = () => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                maxWidth: 900,
                flex: 1,
                justifySelf: 'center',
                padding: 2,
                backgroundColor: theme.palette.background.default,
                minHeight: '100vh',
                overflowY: 'auto',
            }}
        >

            <Typography variant="h5" sx={{ mt: 4, mb: 1, fontWeight: 'bold' }}>
                Objetivos
            </Typography>
            <Typography variant="body1">
                O principal objetivo do APP SIMDOCTOR é disponibilizar junto aos profissionais
                um sistema on-line seguro, que seja referência em terapia comportamental,
                de forma que possam ampliar sua clientela a partir da oferta de psicoterapia
                e teleneuropsicologia a qualquer pessoa que precise destes serviços em
                qualquer lugar do mundo. O SIMDOCTOR APP fica disponível na plataforma SIMDOCTOR
                e pode ser facilmente acessado através de seu aparelho celular.
            </Typography>

            <Typography variant="h5" sx={{ mt: 4, mb: 1, fontWeight: 'bold' }}>
                Quem pode participar/usar
            </Typography>
            <Typography variant="body1">
                Psicólogos e neuropsicólogos que concluíram um curso de pós-graduação ou
                formação no SIMDOCTOR e outros profissionais com pós-graduação em Análise do Comportamento
                mediante aprovação de cadastro. Todos devem ser residentes e atuantes no território brasileiro.
            </Typography>

            <Typography variant="h5" sx={{ mt: 4, mb: 1, fontWeight: 'bold' }}>
                Requisitos necessários
            </Typography>
            <Typography variant="body1">
                Para se cadastrar, os psicólogos e neuropsicólogos interessados devem enviar
                documentos que confirmem/comprovem:
            </Typography>
            <List>
                <ListItem>
                    <ListItemIcon>
                        <CheckCircleOutline color="primary" />
                    </ListItemIcon>
                    <ListItemText primary="Diploma de graduação em Psicologia;" />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        <CheckCircleOutline color="primary" />
                    </ListItemIcon>
                    <ListItemText primary="Inscrição ativa no CRP;" />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        <CheckCircleOutline color="primary" />
                    </ListItemIcon>
                    <ListItemText primary="Cadastro no E-PSI aprovado pelo CRP;" />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        <CheckCircleOutline color="primary" />
                    </ListItemIcon>
                    <ListItemText primary="Certificado de conclusão em um curso de pós-graduação ou formação no SIMDOCTOR ou outro certificado de conclusão de curso de pós-graduação em Análise do Comportamento reconhecido pelo MEC." />
                </ListItem>
            </List>

            <Typography variant="h5" sx={{ mt: 4, mb: 1, fontWeight: 'bold' }}>
                Vantagens em atender pelo APP SIMDOCTOR - Para psicólogos
            </Typography>
            <List>
                <ListItem>
                    <ListItemIcon>
                        <StarRounded color="secondary" />
                    </ListItemIcon>
                    <ListItemText primary="Divulgação de seu nome e currículo por uma instituição sólida que é referência em terapia comportamental online no Brasil;" />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        <StarRounded color="secondary" />
                    </ListItemIcon>
                    <ListItemText primary="Uso de plataforma exclusivamente delineada para o SIMDOCTOR;" />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        <StarRounded color="secondary" />
                    </ListItemIcon>
                    <ListItemText primary="Organização de agenda de atendimentos com flexibilidade de acordo com a sua disponibilidade e preferência;" />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        <StarRounded color="secondary" />
                    </ListItemIcon>
                    <ListItemText primary="Oportunidade de definir de forma personalizada o valor de suas sessões de psicoterapia e neuropsicologia;" />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        <StarRounded color="secondary" />
                    </ListItemIcon>
                    <ListItemText primary="Atendimento pode ser feito em qualquer hora e lugar do país respeitando as exigências mínimas para o atendimento online definidas pelo CFP;" />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        <StarRounded color="secondary" />
                    </ListItemIcon>
                    <ListItemText primary="Alcance ampliado para maior captação de clientes sem restrições geográficas à sua cidade de residência;" />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        <StarRounded color="secondary" />
                    </ListItemIcon>
                    <ListItemText primary="Automação e agilidade no processo de agendamento;" />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        <StarRounded color="secondary" />
                    </ListItemIcon>
                    <ListItemText primary="Repasse imediato após confirmação do pagamento pelo cliente;" />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        <StarRounded color="secondary" />
                    </ListItemIcon>
                    <ListItemText primary="Possibilidade de que profissionais experientes ampliem sua cartela de clientes e preencham horários de sua agenda com atendimentos online." />
                </ListItem>
            </List>

            <Typography variant="h5" sx={{ mt: 4, mb: 1, fontWeight: 'bold' }}>
                Vantagens em atender pelo APP SIMDOCTOR - Para pós-graduados e formados no SIMDOCTOR
            </Typography>
            <List>
                <ListItem>
                    <ListItemIcon>
                        <EmojiEventsOutlined color="primary" />
                    </ListItemIcon>
                    <ListItemText primary="Vantagem no processo seletivo. Quem tem diploma ou certificado de conclusão de uma pós-graduação ou formação no SIMDOCTOR tem seu cadastro automaticamente aprovado no APP Terapia Comportamental Online;" />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        <EmojiEventsOutlined color="primary" />
                    </ListItemIcon>
                    <ListItemText primary="O ex-aluno tem percentual maior no repasse dos atendimentos;" />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        <EmojiEventsOutlined color="primary" />
                    </ListItemIcon>
                    <ListItemText primary="O psicólogo recém-graduado que já possua uma formação no SIMDOCTOR tem oportunidade diferenciada para início imediato na atuação profissional;" />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        <EmojiEventsOutlined color="primary" />
                    </ListItemIcon>
                    <ListItemText primary="Para o ex-aluno, o aplicativo tem a credibilidade da instituição em que já estudou e cuja qualidade conhece diretamente." />
                </ListItem>
            </List>

            <Typography variant="h5" sx={{ mt: 4, mb: 1, fontWeight: 'bold' }}>
                Como funciona
            </Typography>
            <Typography variant="body1">
                Em breve!
            </Typography>

            <Typography variant="h5" sx={{ mt: 4, mb: 1, fontWeight: 'bold' }}>
                Sobre o SIMDOCTOR
            </Typography>
            <Typography variant="body1">
                O SIMDOCTOR destaca-se como uma reconhecida referência em Psicologia Comportamental no Brasil.
                Fundado em 1999, atua fortemente em três setores: qualificação de profissionais,
                oferta de serviços clínicos e atividades de pesquisa e publicação. Na área acadêmica
                são ofertados cursos de pós-graduação e formação, cursos de extensão, minicursos,
                Encontros Científicos de âmbito nacional, Simpósios nacionais e internacionais,
                Jornadas, workshops, inglês instrumental e estágio supervisionado. No setor clínico
                o SIMDOCTOR disponibiliza psicoterapia, avaliação neuropsicológica, orientação profissional,
                orientação de pais e avaliações pré-cirúrgicas. Estes serviços podem ser realizados
                na clínica particular ou clínica-escola e são destinados a crianças, adolescentes,
                adultos, idosos e casais. Todos disponíveis no modo online ou presencial. O SIMDOCTOR também
                atua no setor de pesquisa e publicação com a Revista Jornadas, o Blog do SIMDOCTOR,
                o Podcast Ciência e Comportamento, além de grupos de estudos/pesquisa regulares
                iniciados a cada semestre.
            </Typography>
            <div style={{
                        flex: 1,
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                <StyledButton
                    sx={{
                        flex: 1,
                        justifyContent: 'center',
                        justifySelf: 'center',
                        width: 300
                    }}
                    variant="contained"
                    onClick={() => window.location.href = '/register'}
                >
                    Continuar
                </StyledButton>
            </div>
        </Box>
    );
};

export default SimDoctorInfoScreen;